import AutomationRulesUpsellSvg from 'ext-ui/svg/illustration/AutomationRulesUpsellSvg'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import AutomationRulesList from 'src/components/AutomationRulesList/AutomationRulesList'
import AutomationRulesSettings from 'src/components/AutomationRulesSettings/AutomationRulesSettings'
import SaasUpgradeOrContent from 'src/feature/SaasUpgradeOrContent/SaasUpgradeOrContent'
import Trns, { useTranslate } from 'src/localization/Trns'
import { UserFeature } from 'src/models/user.models'
import Lnk from 'src/navigation/Lnk'
import { selectAppName } from 'src/redux/selectors/session.selectors'

const AutomationRules: React.FC = () => {
  const appName = useSelector(selectAppName)
  const translate = useTranslate()

  return (
    <>
      <Helmet>
        <title>{`Rules | ${appName}`}</title>
        <meta name="description" content={`Rules page of ${appName}`} />
      </Helmet>
      <SaasUpgradeOrContent
        illustration={<AutomationRulesUpsellSvg />}
        title={translate('Accounting Rules')}
        description={translate(
          'Configure expense category rules that will automatically code transactions. Rules can apply to transactions made with different credit cards or budgets*, merchant category codes, and merchant names.',
        )}
        disclaimer={
          <Trns
            source="*Budgets available for ${selectIssuersLink}"
            expressions={{
              selectIssuersLink: (
                <Lnk
                  className="underline-link"
                  href="https://support.paywithextend.com/hc/en-us/sections/35632429037079-Registering-a-Card-Account"
                  ariaLabel={translate('select issuers')}
                >
                  {translate('select issuers')}
                </Lnk>
              ),
            }}
          />
        }
        ctaDetailSrc={'Upgrade to ${tier} today and save hours on bookkeeping.'}
        feature={UserFeature.EXPENSE_CATEGORY_RULES}
      >
        <div className={'w-full flex-column align-center'}>
          <AutomationRulesSettings />
          <AutomationRulesList />
        </div>
      </SaasUpgradeOrContent>
    </>
  )
}

export default AutomationRules
